import { usePlatformGet } from '@reapitform/hooks'

export interface IUserProfileData {
  referenceID: string
  agencyId: string
  firstName: string
  lastName: string
  email: string
  phone: string
  mobile: string
}

export const useUserProfile = (referenceId = '8cf19e73-8acf-4675-bcc7-951262e2ef75') => {
  const [result, loading, errorString] = usePlatformGet<IUserProfileData>({
    path: `/api/User/${referenceId}`,
    retry: false,
    isProtectedRoute: false,
    headers: { accept: 'application/json' },
  })

  const defaultResult: IUserProfileData = {
    agencyId: '',
    email: '',
    firstName: '',
    lastName: '',
    mobile: '',
    phone: '',
    referenceID: '',
  }

  return { data: result || defaultResult, loading, errorString }
}
